/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseChecklistField
 */
export interface DatabaseChecklistField extends DatabaseField {
    /**
     * 
     * @type {number}
     * @memberof DatabaseChecklistField
     */
    max?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseChecklistField
     */
    inlineMode?: DatabaseChecklistFieldInlineModeEnum;
    /**
     * Vordefinierte Checklist-Einträge (Label), werden bei neuen Datensätzen als unchecked vorbelegt
     * @type {Array<string>}
     * @memberof DatabaseChecklistField
     */
    defaultItems?: Array<string>;
}


/**
 * @export
 */
export const DatabaseChecklistFieldInlineModeEnum = {
    Status: 'STATUS',
    Detail: 'DETAIL'
} as const;
export type DatabaseChecklistFieldInlineModeEnum = typeof DatabaseChecklistFieldInlineModeEnum[keyof typeof DatabaseChecklistFieldInlineModeEnum];


/**
 * Check if a given object implements the DatabaseChecklistField interface.
 */
export function instanceOfDatabaseChecklistField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseChecklistFieldFromJSON(json: any): DatabaseChecklistField {
    return DatabaseChecklistFieldFromJSONTyped(json, false);
}

export function DatabaseChecklistFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseChecklistField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'max': !exists(json, 'max') ? undefined : json['max'],
        'inlineMode': !exists(json, 'inlineMode') ? undefined : json['inlineMode'],
        'defaultItems': !exists(json, 'defaultItems') ? undefined : json['defaultItems'],
    };
}

export function DatabaseChecklistFieldToJSON(value?: DatabaseChecklistField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'max': value.max,
        'inlineMode': value.inlineMode,
        'defaultItems': value.defaultItems,
    };
}

